import {  IUserSettings } from "./useDashboardQueries";

  export const getUpdatedFilterModel = (dashboardId:string,settings:any,updatedFilter:any) => {
      try {
        const dashboardExists = settings.dashboard.some((dash:any) => dash.id === dashboardId);
        let model = null;
        if(dashboardExists){
          model = {
            ...settings,
            dashboard: settings?.dashboard?.map((dash:any) =>
              dash.id === dashboardId
                ? { ...dash, filter: updatedFilter , widgets: dash.widgets}
                : dash
            ),
          };
        }else {
          model = {
            ...settings,
            dashboard: [
              ...settings.dashboard,
              {
                id: dashboardId,
                filter: updatedFilter,
                widgets:[]
              },
            ],
          };
        }
        return model as IUserSettings;
      } catch (e) {
        console.log(e)
      }
  }

  export const getUpdatedWidgetModel = (dashboardId:string,settings:any,updatedWidget:any) => {
      try {
        
        const dashboard = settings.dashboard?.find((dash: any) => dash.id === dashboardId);
        const dashboardExists = !!dashboard;
        const widgetId = updatedWidget.id;
        // Check if widget exists within that dashboard
        const widgetExists = dashboard?.widgets?.some((widget: any) => widget.id === widgetId);

        let model = null;

        if (dashboardExists) {
          model = {
            ...settings,
            dashboard: settings.dashboard.map((dash: any) =>
              dash.id === dashboardId
                ? {
                    ...dash,
                    filter: dash.filter,
                    widgets: widgetExists
                      // Update existing widget
                      ? dash.widgets.map((widget: any) =>
                          widget.id === widgetId
                            ? { ...widget, ...updatedWidget }
                            : widget
                        )
                      // Add new widget
                      : [...(dash.widgets || []), updatedWidget],
                  }
                : dash
            ),
          };
        } else {
          // Create new dashboard with widget
          model = {
            ...settings,
            dashboard: [
              ...(settings.dashboard || []),
              {
                id: dashboardId,
                widgets: [updatedWidget],
              },
            ],
          };
        }

        return model;
      }catch(e){
        console.log(e)
      }
        
  }

export function toTitleCase(str:any) {
  return str
    .toLowerCase()
    .replace(/\b\w/g, (char:any) => char.toUpperCase());
}
